import { get } from 'lodash-es';

export const rootNode = document.getElementById('report-analysis-search-root');
const widgetFieldsNode = document.getElementById('report-widget-fields');
const coverImageNode = document.getElementById('report-cover-image');

const parseRootNode = (dataName, defaultValue) =>
  rootNode.dataset[dataName] ? JSON.parse(rootNode.dataset[dataName]) : defaultValue;

const parseWidgetFieldsNode = (dataName) => {
  const widgetFields = get(widgetFieldsNode, ['dataset', dataName]);
  return widgetFields && JSON.parse(widgetFields);
};

const parseImageNode = (dataName, defaultValue) =>
  coverImageNode && coverImageNode.dataset[dataName]
    ? JSON.parse(coverImageNode.dataset[dataName])
    : defaultValue;

export const initParams = {
  isAdminFlow: parseRootNode('isAdminFlow', false),
  isMobileModalFlow: parseRootNode('isMobileModalFlow', false),
  customMobileFields: parseWidgetFieldsNode('customMobileFields'),
  customDesktopFields: parseWidgetFieldsNode('customDesktopFields'),

  showReportUpdatedState: parseRootNode('reportUpdatedState', false),
  preSelectedApp: parseRootNode('appsGeneralData', []),
  topPopularApps: parseRootNode('topPopularApps', []),
  coverImage: parseImageNode('coverImage', []),

  sitekey: rootNode.dataset.sitekey,
  sharedByReportId: rootNode.dataset.sharedByReportId,
  designType: rootNode.dataset.designType,
  env: rootNode.dataset.env,
};
